/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ipam';
const componentName = 'ipam-dns-profile-modal';
const prefix = `${moduleName}.${componentName}`;

export const modalTitleEdit = `${prefix}.modalTitleEdit`;
export const modalTitleNew = `${prefix}.modalTitleNew`;
export const sectionTitleGeneral = `${prefix}.sectionTitleGeneral`;
export const nameInputLabel = `${prefix}.nameInputLabel`;
export const typeDropdownLabel = `${prefix}.typeDropdownLabel`;
export const nameInputPlaceholder = `${prefix}.nameInputPlaceholder`;
export const typeDropdownPlaceholder = `${prefix}.typeDropdownPlaceholder`;
export const sectionTitleInfoblox = `${prefix}.sectionTitleInfoblox`;
export const allocateIpInVrfCheckboxLabel = `${prefix}.allocateIpInVrfCheckboxLabel`;
export const aviSectionHeader = `${prefix}.aviSectionHeader`;
export const sectionTitleCustom = `${prefix}.sectionTitleCustom`;
export const sectionTitleAzure = `${prefix}.sectionTitleAzure`;
export const sectionTitleAws = `${prefix}.sectionTitleAws`;

export const ENGLISH = {
    [modalTitleEdit]: 'Edit {0} Profile',
    [modalTitleNew]: 'New {0} Profile',
    [sectionTitleGeneral]: 'General',
    [nameInputLabel]: 'Name',
    [typeDropdownLabel]: 'Type',
    [nameInputPlaceholder]: 'Enter Name',
    [typeDropdownPlaceholder]: 'Select Type',
    [sectionTitleInfoblox]: 'Infoblox {0}',
    [aviSectionHeader]: 'Avi {0}',
    [allocateIpInVrfCheckboxLabel]: 'Allocate IP in VRF',
    [sectionTitleCustom]: 'Custom {0}',
    [sectionTitleAzure]: 'Azure {0}',
    [sectionTitleAws]: 'AWS {0}',
};
